<h1 class="!pb-0" mat-dialog-title>Add {{ entityType }}</h1>

<mat-dialog-content class="!flex flex-col content-center justify-center gap-4">
  <span>Type an {{ entityType }} number to add to this timesheet</span>

  <mat-form-field>
    <mat-label class="capitalize">{{ entityType }} Number</mat-label>
    <mat-hint class="text-gray-500">No more than 8 numbers </mat-hint>
    <input type="text" pattern="^[0-9]*$" maxlength="8" matInput [formControl]="entityNumCtrl" />
    @if (!entityNumCtrl.pending && entityNumCtrl.hasError('pattern')) {
      <mat-error> An {{ entityType }} number should only contain numbers </mat-error>
    }
    @if (!entityNumCtrl.pending && entityNumCtrl.hasError('maxlength')) {
      <mat-error
        >This {{ entityType }} number has {{ entityNumCtrl.errors['maxlength'].actualLength }} numbers,
        <br />
        but it shouldn't have more than {{ entityNumCtrl.errors['maxlength'].requiredLength }}
      </mat-error>
    }
    @if (!entityNumCtrl.pending && entityNumCtrl.hasError('notEntity')) {
      <mat-error>
        <span class="capitalize">{{ entityType }}</span>
        <strong> #{{ debouncedValue }}</strong>
        was not found
      </mat-error>
    }
    @if (!entityNumCtrl.pending && entityNumCtrl.hasError('unavailable')) {
      <mat-error>
        <span class="capitalize">{{ entityType }}</span>
        <strong> #{{ debouncedValue }}</strong>
        is not available
      </mat-error>
    }
  </mat-form-field>

  <div class="flex min-h-[30px] justify-center">
    @if (entityNumCtrl.pending) {
      <mat-spinner diameter="30" />
    } @else if (entityResultDisplay && entityNumCtrl.valid) {
      <div class="flex text-lg">
        @if (entityType === 'employee') {
          <mat-icon>person</mat-icon>
        } @else if (entityType === 'equipment') {
          <mat-icon>local_shipping</mat-icon>
        }
        <span>{{ entityResultDisplay }}</span>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  @if ((entityNumCtrl.invalid && entityNumCtrl.errors?.['notEntity']) || entityNumCtrl.errors?.['unavailable']) {
    <button mat-raised-button color="primary" (click)="easyTicket()">I Need Help</button>
  }
  <button mat-raised-button [disabled]="!entityResultDisplay || entityNumCtrl.invalid || entityNumCtrl.pending" (click)="close()">
    @if (entityType === 'employee') {
      <mat-icon>person_add</mat-icon>
    } @else if (entityType === 'equipment') {
      <mat-icon>local_shipping</mat-icon>
    }
    Add {{ entityResultDisplay }} to Timesheet
  </button>
</mat-dialog-actions>
